var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Config from "../../config";
import jsons from "../json";
const { DEFAULT_PAGE_SIZE } = Config;
export class LocalLookupService {
    constructor(route, disableSort) {
        this.data = jsons[route];
        this.disableSort = disableSort;
    }
    getAll(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let filteredData = this.filterData(this.data, params);
            if (!this.disableSort) {
                filteredData = filteredData.sort((a, b) => a.name < b.name ? -1 : 1);
            }
            const filterAndPagedData = this.pageData(filteredData, params);
            return filterAndPagedData;
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.data.find(item => item["id"] === id);
        });
    }
    filterData(baseData, { query } = {}) {
        const applyItemFilter = (item, query) => {
            const wordsToSearchFor = query.trim().toLocaleLowerCase().split(" ");
            const valuesToSearch = Object.values(item)
                .filter(value => !!value)
                .map(value => String(value).toLocaleLowerCase());
            // XXX: Bloody hell this is bad. There's gotta be a better way to think about filters, like specify the key we're searching for
            return wordsToSearchFor.every(wordToSearchFor => valuesToSearch.some(value => value.length === wordToSearchFor.length && value.includes(wordToSearchFor)));
        };
        return query ? baseData.filter(item => applyItemFilter(item, query)) : baseData;
    }
    pageData(baseData, { page } = {}) {
        const totalCount = baseData.length;
        return page !== undefined
            ? {
                data: baseData.slice(page * DEFAULT_PAGE_SIZE, page * DEFAULT_PAGE_SIZE + DEFAULT_PAGE_SIZE),
                totalCount,
                page,
                totalPages: Math.ceil(totalCount / DEFAULT_PAGE_SIZE),
                pageSize: DEFAULT_PAGE_SIZE,
            }
            : {
                data: baseData,
                totalCount,
            };
    }
}
